import CustomImageComponent from '../custom/custom-image';

const MisterFantasyIcon = ({ width, height, style }) => {
    return (
        <CustomImageComponent
            src={`${process.env.NEXT_PUBLIC_IMAGES}/logos/mister.png?width=${width * 1.5}`}
            width={width ?? 30}
            height={height ?? width ?? 30}
            alt={'mister-fantasy'}
            style={style}
        />
    );
};

export default MisterFantasyIcon;
